/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import _Popup from './popup.mjs';
import withInstall from '../utils/withInstall.mjs';
import './style/css.mjs';
import './type.mjs';
import '../_chunks/dep-8d3c9348.mjs';
import '../_chunks/dep-d531a7f4.mjs';
import '../_chunks/dep-6e49aa22.mjs';
import '../_chunks/dep-6da93342.mjs';
import 'vue';
import '@popperjs/core';
import 'lodash-es';
import '../hooks/index.mjs';
import '../hooks/icon.mjs';
import '../hooks/slot.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-5112e56c.mjs';
import '../hooks/useConfig.mjs';
import '../config-provider/hooks/useConfig.mjs';
import '../config-provider/utils/context.mjs';
import '../_chunks/dep-99da72b8.mjs';
import '../_chunks/dep-b0ea6825.mjs';
import '../_chunks/dep-2705c570.mjs';
import '../_chunks/dep-bc824998.mjs';
import '../config-provider/type.mjs';
import '../hooks/useCommonClassName.mjs';
import '../hooks/useDefaultValue.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../hooks/useRipple.mjs';
import '../_chunks/dep-b0b0fb5e.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../hooks/useVModel.mjs';
import '../hooks/useImagePreviewUrl.mjs';
import '../_chunks/dep-46061e10.mjs';
import '../_chunks/dep-1def7a80.mjs';
import '../utils/dom.mjs';
import './container.mjs';
import '../_chunks/dep-35b16530.mjs';
import './props.mjs';
import '../hooks/useResizeObserver.mjs';

var Popup = withInstall(_Popup);

export { Popup, Popup as default };
//# sourceMappingURL=index.mjs.map
